<template>
    <div id="main">
        <div class="dataBlock">
            <div><span class="font-weight-bold">{{$t('name')}} :</span> {{name}}</div>
            <div><span class="font-weight-bold">{{$t('nickname')}} :</span> {{nickname}}</div>
            <div><span class="font-weight-bold">{{$t('birthdate')}} :</span> <router-link to="/project/birthdate">{{birthdate | date(lang)}}</router-link></div>
            <div><span class="font-weight-bold">{{$t('email')}} :</span> <a :href="`mailto:${email}`">{{email}}</a> </div>
            <div><span class="font-weight-bold">{{$t('tel')}} :</span> <a :href="`tel:+66${tel.slice(1,10)}`">{{tel}}</a></div>
            <div>
                <div>
                    <span class="font-weight-bold">{{$t('exp')}} :</span> 
                </div>
                <ul>
                    <li v-for="(exp,index) in exp" :key="index">{{exp.company}} ({{exp.position}}) ({{expLang(exp.start,exp.end)}})</li>
                </ul>
            </div>
            <div>
                <div style="display:inline-flex;height:100%;float: left;">
                    <span class="font-weight-bold">{{$t('skill')}} :</span> 
                </div>
                <ul class="flex">
                    <li v-for="skill in skillLoad" :key="skill.skill">
                        {{skill.skill}}
                    </li>
                </ul>
                <div style="padding-left:80px;display:inline-block">
                    <a v-if="isLoadMore==0" href="#" @click.prevent="isLoadMore=1">{{$t('showMore')}}</a>
                    <a v-else href="#" @click.prevent="isLoadMore=0">{{$t('showLess')}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
var moment = require('moment');
export default {
    filters : {
        date : function(date,lang){
            if(lang !='th') return moment(date,'DD/MM/YYYY').format('DD MMMM YYYY')
            else return moment(date,'DD/MM/YYYY').locale('th').format('DD MMMM YYYY')
        },
        workExp : function(date,lang,endDate){
           var end = moment()
           if(endDate) end = moment(endDate,'DD/MM/YYYY')
           var work = moment(date,"DD/MM/YYYY")
           var diff = moment.duration(end.diff(work),'milliseconds')
           var year = diff.years()
           var month = diff.months();
           var day = diff.days();
           if(day >= 15) month++
           if(month==12) year++
           console.log(this)
           var nowExp = `${year>0?this.$t("yearExp",year):''}`;
           return nowExp
        }.bind(this)
    },
    data : function(){
        return {
            skills : [],
            isLoadMore : 0
        }
    },
    methods:{
        expLang(expStart,expEnd){
            var end = moment()
            if(expEnd) end = moment(expEnd,'DD/MM/YYYY')
            var work = moment(expStart,"DD/MM/YYYY")
            var diff = moment.duration(end.diff(work),'milliseconds')
            var year = diff.years()
            var month = diff.months();
            var day = diff.days();
            if(day >= 15) month++
            if(month==12) {
                year++
                month=0
            }
            var nowExp = `${year>0?this.$tc("yearExp",year,{year}):''}${month>0?` ${this.$tc("monthExp",month,{month})}`:''}`;
            return nowExp
        }
    },
    computed : Object.assign({
            skillLoad : function(){
                var allSkill = this.skills
                if(this.isLoadMore===0){
                    allSkill = allSkill.slice(0,4)
                }
                return allSkill
            },
        },mapGetters(['name','nickname','birthdate','lang','email','tel','exp'])
    ),
    mounted :function(){
        this.skills = this.$store.getters.skills
    }
}
</script>
<style scoped>
    #main{
        text-transform: none;
        text-align: center;
        justify-content: center;
        font-size: 17px;
        width: 37rem;
    }

    #main div.dataBlock{
        justify-content: center;
        justify-items: center;
        padding: 5px 0px;
        width: auto;
        text-align: left;
        display: inline-block;
    }

    ul.flex{
        flex-wrap: wrap;
        list-style-position: inside;
        display: flex;
        margin: 0px;
        padding-left: 0px;
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }

    ul{
       margin: 0px;
    }

    li{
        flex: 1 0 50%;
    }

</style>


// WEBPACK FOOTER //
// src/components/aboutMe.vue